"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var findPlanElement_1 = require("./datalayerHelpers/findPlanElement");
var generateNewTag_1 = require("./datalayerHelpers/generateNewTag");
var insertPlacement_1 = require("./datalayerHelpers/insertPlacement");
var checkForValidFrequencyCapping_1 = require("./datalayerHelpers/checkForValidFrequencyCapping");
var GroupManager = (function () {
    function GroupManager() {
    }
    GroupManager.prototype.checkValidFCPromise = function (newPlacement, isPreset, rateCardOptions) {
        return checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(newPlacement, -1, isPreset, rateCardOptions).then(function (checkResult) {
            if (checkResult === true) {
                newPlacement.additionalData.frequencyCappingFormatted = (_.get(newPlacement, "frequencyCapping.impressions")) || "";
                newPlacement.additionalData.frequencyCappingForTotal = (_.get(newPlacement, "frequencyCapping.forTotal")) || undefined;
            }
            else {
                _.set(newPlacement, "additionalData.frequencyCappingFormatted", configuration_1.PlanConfiguration.ERROR_STRING);
                _.set(newPlacement, "additionalData.frequencyCappingForTotal", undefined);
                delete newPlacement.frequencyCapping;
            }
        });
    };
    GroupManager.prototype.addGroupRow = function (plan, preset, row, ratecardOptions) {
        var _a = findPlanElement_1.findPlanElement(plan, row), groupIndex = _a.groupIndex, placementIndex = _a.placementIndex;
        var mediumGroups = plan.mediumGroups;
        var mediumGroup = mediumGroups[groupIndex];
        var placement = mediumGroup.mediumGroup[placementIndex];
        var medium = (placement ? placement : mediumGroup.mediumGroup[0]).medium;
        var newPlacement = _.assign({}, preset, { medium: _.assign({}, medium, { period: preset.medium.period }) });
        _.set(newPlacement, "tag", generateNewTag_1.generateNewTag());
        return this.checkValidFCPromise(newPlacement, false, ratecardOptions).then(function () {
            var newMediumGroup = insertPlacement_1.insertPlacement(mediumGroup, mediumGroup.mediumGroup.length, newPlacement);
            var newMediumGroups = mediumGroups.slice();
            newMediumGroups[groupIndex] = newMediumGroup;
            var newPlan = _.assign({}, plan, { mediumGroups: newMediumGroups });
            return newPlan;
        });
    };
    GroupManager.getCurrentCaption = function (currentColumns, groupField) {
        if (!groupField) {
            return undefined;
        }
        var theColumn = _.find(currentColumns, function (candidate) {
            return candidate.dataPath === groupField.tableField;
        });
        if (!theColumn) {
            return undefined;
        }
        return theColumn.longCaption !== undefined ? theColumn.longCaption : theColumn.caption;
    };
    GroupManager.prototype.groupByGroupField = function (rows, currentColumns, groupField) {
        if (!groupField) {
            return rows;
        }
        var contentRows = rows.filter(function (row) {
            return !row.isReadOnly;
        });
        var grouped = _.groupBy(contentRows, function (candidate) {
            return _.get(candidate, groupField.dataField) || groupField.notFoundText;
        });
        var sorted = _.sortBy(contentRows, function (item) {
            return _.get(item, groupField.displayField);
        });
        var sortedKeys = _.uniq(sorted.map(function (item) {
            return _.get(item, groupField.dataField) || groupField.notFoundText;
        }));
        var result = [];
        sortedKeys.forEach(function (key) {
            if (grouped.hasOwnProperty(key)) {
                var theRows = grouped[key];
                if (key === "") {
                    result.push.apply(result, theRows);
                }
                else {
                    var displayValue = _.get(theRows[0], groupField.displayField) || groupField.notFoundText;
                    result.push({
                        isReadOnly: true,
                        groupCaption: (GroupManager.getCurrentCaption(currentColumns, groupField) || "Medium") + ": " + displayValue
                    });
                    result.push.apply(result, theRows);
                }
            }
        });
        return result;
    };
    return GroupManager;
}());
exports.GroupManager = GroupManager;
//# sourceMappingURL=groupManager.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/groupManager.js
// module id = 54
// module chunks = 0